import { RouteRecordRaw } from 'vue-router';
import MiddlePageNetworkError from './middle-page-network-error.vue';

export const ROUTE_NAME_MIDDLE_NETWORK_ERROR = 'middle-page-network-error';
export const middlePageNetworkErrorRouter: RouteRecordRaw[] = [
  {
    path: '/middle-page-network-error',
    name: ROUTE_NAME_MIDDLE_NETWORK_ERROR,
    component: MiddlePageNetworkError,
  },
];
